module.exports = __webpack_public_path__ + "images/emoji/gift_heart.7fd3afb0896a785236cb.png";